class AddToButtonStickey extends HTMLElement {
  constructor() {
    super();
    // 元の位置に戻すための参照を保持する
    this.originalPlaceholder = null;
    this.originalParent = null;
    this.toggleVisibility = this.toggleVisibility.bind(this);
    this.openSideMenu = this.openSideMenu.bind(this);
    this.handleCloseClick = this.handleCloseClick.bind(this);
    this.handleMfpClose = this.handleMfpClose.bind(this);
  }

  connectedCallback() {
    this.mediaQuery = window.matchMedia('(max-width: 980px)');

    window.addEventListener('scroll', this.toggleVisibility);
    window.addEventListener('resize', this.toggleVisibility);
    window.addEventListener('touchmove', this.toggleVisibility);
    this.addEventListener('click', this.openSideMenu);
    this.addEventListener('touchend', this.openSideMenu);
    // document.addEventListener('click', this.handleCloseClick);
    // document.addEventListener('touchend', this.handleCloseClick);
    // Magnific Popupが閉じたときにも復帰させる
    if (window.jQuery) {
      window.jQuery(document).on('mfpClose.addToButtonSticky', this.handleMfpClose);
    }
    this.toggleVisibility();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.toggleVisibility);
    window.removeEventListener('resize', this.toggleVisibility);
    window.removeEventListener('touchmove', this.toggleVisibility);
    this.removeEventListener('click', this.openSideMenu);
    this.removeEventListener('touchend', this.openSideMenu);    
    // document.removeEventListener('click', this.handleCloseClick);
    // document.removeEventListener('touchend', this.handleCloseClick);
    // 監視イベントを解除する
    if (window.jQuery) {
      window.jQuery(document).off('mfpClose.addToButtonSticky', this.handleMfpClose);
    }
    this.restoreFormPosition();
  }

  toggleVisibility() {

    const isSP = this.mediaQuery.matches;
    if (isSP) {
      const target = document.querySelector('#product-form-inner');
      if (target) {
        const rect = target.getBoundingClientRect();
        const isPastTarget = rect.bottom < 0;
        this.classList.toggle('visible', isPastTarget);
        this.classList.toggle('hidden', !isPastTarget);
        return;
      }
    }

    const scrollY = window.scrollY;
    const innerHeight = window.innerHeight;

    const isScrolledPastViewport = scrollY > innerHeight;

    if (isScrolledPastViewport) {
      this.classList.add('visible');
      this.classList.remove('hidden');
    } else {
      this.classList.remove('visible');
      this.classList.add('hidden');
    }
  }

  openSideMenu() {
    // クリック時にフォームをstickyコンテンツへ移動する
    const productFormInner = document.querySelector('.js-product-form');
    const stickyContent = document.querySelector('.product-single__box__block--buy_buttons_sticky-content');
    if (!productFormInner || !stickyContent) return;
    if (stickyContent.contains(productFormInner)) return;

    // 初回移動時のみ元の位置情報を保存する
    if (!this.originalPlaceholder) {
      this.originalPlaceholder = document.createComment('product-form-inner-original-position');
      this.originalParent = productFormInner.parentNode;
      this.originalParent.insertBefore(this.originalPlaceholder, productFormInner);
    }

    // フォームを移すと親が潰れてレイアウトがガクッとなるので、移動直前の親ボックス高さを min-height で保持する（復元時に解除）
    if (
      this.originalParent &&
      this.originalParent.nodeType === Node.ELEMENT_NODE
    ) {
      const parentHeight = this.originalParent.offsetHeight;
      if (parentHeight > 0) {
        this.originalParent.style.minHeight = `${parentHeight}px`;
      }
    }

    stickyContent.appendChild(productFormInner);
    productFormInner.classList.add('open-side-menu');
  }

  handleCloseClick(event) {
    // タッチイベントでも安全にElementとして扱う
    const eventTarget = event.target instanceof Element ? event.target : null;
    if (!eventTarget) return;

    // 閉じる操作のトリガーを検出する
    const closeTrigger = eventTarget.closest(
      '[data-sticky-close], .js-sticky-close, .sticky-close, .js-close-mfp, .mfp-close, .mfp-close-btn-in ,[aria-label="閉じる"], [aria-label="close"]'
    );
    const isCloseTextButton =
      eventTarget.closest('button, a') &&
      eventTarget.closest('button, a').textContent.trim() === '閉じる';

    if (!closeTrigger && !isCloseTextButton) return;
    this.restoreFormPosition();
  }

  handleMfpClose() {
    // 背景タップやスワイプ閉じでも元へ戻す
    this.restoreFormPosition();
  }

  restoreFormPosition() {
    // 保存したプレースホルダー位置にフォームを戻す
    const productFormInner = document.querySelector('.js-product-form');
    if (!productFormInner || !this.originalPlaceholder || !this.originalParent) return;

    this.originalParent.insertBefore(productFormInner, this.originalPlaceholder);
    this.originalPlaceholder.remove();
    this.originalPlaceholder = null;
    // 開いたときに付けた min-height を戻すので、クローズ後は通常どおりの高さに戻る
    this.originalParent.style.minHeight = '';
    this.originalParent = null;
    productFormInner.classList.remove('open-side-menu');
  }
}

customElements.define('add-to-button-sticky', AddToButtonStickey);
